export default __webpack_public_path__ + "static/media/Graphik-Extralight.f0f07053.otf";